import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FOLDER_DIRECTORIES } from '../constants/folder';
import buildFoldersTree from '../utils/build-folders-tree';

type FoldersSplit = {
    archive?: Folder;
    list: Folder[];
    tree: Folder[];
    ownList: Folder[];
    ownTree: Folder[];
    sharedList: Folder[];
    sharedTree: Folder[];
    loaded: boolean;
};

const useFoldersSplit = (directory: FOLDER_DIRECTORIES): FoldersSplit => {
    const slot = useSelector((state: RootState) => state.main.folders[directory]);

    return useMemo(() => {
        const ownList = slot.list.filter((folder) => folder.is_shared !== true);
        const sharedList = slot.list.filter((folder) => folder.is_shared === true);

        return {
            archive: slot.archive,
            list: slot.list,
            loaded: slot.loaded,
            ownList,
            ownTree: buildFoldersTree(ownList),
            sharedList,
            sharedTree: buildFoldersTree(sharedList),
            tree: slot.tree
        };
    }, [slot.list, slot.tree, slot.loaded, slot.archive]);
};

export default useFoldersSplit;
